<template>
  <a-layout>
    <a-space>
      <a-input-search v-model="query['orderType.name']" :placeholder="$t('business.label.orderTypeName')" @pressEnter="search" @search="search"/>
      <a-input-search v-model="query['storer.name']" :placeholder="$t('business.label.storerName')" @pressEnter="search" @search="search"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :scroll-x="{enabled: true}"
      :height="height"
      size="mini"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>edit(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :cell-render="{name:'FormatSelect',options:packTypes}" field="packType" title="business.label.packType"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoomName"/>
      <vxe-column field="shipOrder" title="business.label.shipOrder"/>
      <vxe-column field="storer.name" title="business.label.storer"/>
      <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
      <vxe-column field="itemType.name" title="business.label.itemType"/>
      <vxe-column fixed="right" title="business.label.operate">
        <template #default="{row}">
          <a @click="edit(row)">{{$t('button.edit')}}</a>
          <a-divider type="vertical"/>
          <a-popconfirm v-if="row" title="是否确定删除？" @confirm="()=>remove(row)">
            <a>{{$t('button.delete')}}</a>
          </a-popconfirm>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <storage-room-shipment-rule-modal ref="shipmentRuleModal" :pack-types="packTypes" @saveSuccess="refresh()"/>
  </a-layout>
</template>

<script>
import { deleteOne, findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import StorageRoomShipmentRuleModal from '@/views/basedata/storageroom_maintenance/StorageRoomShipmentRuleModal.vue'

export default {
  name: 'StorageRoomShipmentRuleTable',
  components: { StorageRoomShipmentRuleModal },
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'orderType.name': '',
        'storer.name': '',
        'storageRoom.ids': null
      },
      storageRoom: null,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.775)
    }
  },
  props: {
    packTypes: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    refresh(record) {
      if (record) {
        const args = { 'storageRoom.ids': [record.id] }
        this.storageRoom = record
        Object.assign(this.query, args)
      }
      if (this.storageRoom === null || this.storageRoom === undefined) {
        return this.$message.warning('请先选择库房')
      }
      this.loading = true
      findAll('shipmentRuleFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    search() {
      this.page = 1
      this.refresh()
    },
    reset() {
      this.query['storageRoom.name'] = ''
      this.query['orderType.name'] = ''
      this.query['storer.name'] = ''
      this.page = 1
      this.size = 20
      this.refresh()
    },
    add() {
      this.$refs.shipmentRuleModal.add(this.storageRoom)
    },
    edit(row) {
      this.$refs.shipmentRuleModal.edit(row)
    },
    remove(row) {
      this.loading = true
      if (row) {
        deleteOne('shipmentRuleDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.$message.success('删除成功')
            this.search()
          }
        }).finally(() => this.loading = false)
      }
    },
    exportExcel() {
      this.$refs.table.openExport()
    }
  }
}
</script>